export const APPOINTMENT_CANCEL           = 'APPOINTMENT_CANCEL';
export const APPOINTMENT_CANCEL_DONE      = 'APPOINTMENT_CANCEL_DONE';

export const APPOINTMENT_CLOSE            = 'APPOINTMENT_CLOSE';
export const APPOINTMENT_CLOSE_DONE       = 'APPOINTMENT_CLOSE_DONE';

export const APPOINTMENT_OPEN             = 'APPOINTMENT_OPEN';
export const APPOINTMENT_OPEN_DONE        = 'APPOINTMENT_OPEN_DONE';

export const APPOINTMENT_CONFIRM          = 'APPOINTMENT_CONFRIM';
export const APPOINTMENT_CONFIRM_DONE     = 'APPOINTMENT_CONFIRM_DONE';

export const APPOINTMENT_CREATE           = 'APPOINTMENT_CREATE';
export const APPOINTMENT_CREATE_DONE      = 'APPOINTMENT_CREATE_DONE';

export const APPOINTMENT_LIST_CLEAR       = 'APPOINTMENT_LIST_CLEAR';

export const APPOINTMENT_LIST_FETCH       = 'APPOINTMENT_LIST_FETCH';
export const APPOINTMENT_LIST_FETCH_DONE  = 'APPOINTMENT_LIST_FETCH_DONE';

export const APPOINTMENT_UPDATE           = 'APPOINTMENT_UPDATE';
export const APPOINTMENT_UPDATE_DONE      = 'APPOINTMENT_UPDATE_DONE';

export const APPOINTMENT_SHOW             = 'APPOINTMENT_SHOW';

export const APPOINTMENT_CURRENT_REP_FETCH = 'APPOINTMENT_CURRENT_REP_FETCH';



// WEBPACK FOOTER //
// ./app/constants/appointmentTypes.js